(function() {
    const initCmDrawers = function() {
      document.querySelectorAll('.cm-hero-trigger').forEach(btn => {
          if (btn.getAttribute('data-cm-bound')) return;
          btn.setAttribute('data-cm-bound', 'true');

          btn.addEventListener('click', function(e) {
              e.preventDefault();
              const targetId = this.getAttribute('data-cm-target');
              const drawer = document.getElementById(targetId);
              const section = this.closest('.shopify-section') || document;
              const overlay = section.querySelector('.cm-section-drawer-overlay');
              
              if(drawer && overlay) {
                  drawer.classList.add('is-active');
                  overlay.classList.add('is-active');
                  document.body.style.overflow = 'hidden';
              }
          });
      });

      const closeDrawers = function() {
          document.querySelectorAll('.cm-section-drawer-wrapper').forEach(d => d.classList.remove('is-active'));
          document.querySelectorAll('.cm-section-drawer-overlay').forEach(o => o.classList.remove('is-active'));
          document.body.style.overflow = '';
      };

      document.querySelectorAll('.cm-section-drawer-close').forEach(btn => {
          if (btn.getAttribute('data-cm-bound')) return;
          btn.setAttribute('data-cm-bound', 'true');
          btn.addEventListener('click', closeDrawers);
      });

      document.querySelectorAll('.cm-section-drawer-overlay').forEach(overlayEnv => {
          if (overlayEnv.getAttribute('data-cm-bound')) return;
          overlayEnv.setAttribute('data-cm-bound', 'true');
          overlayEnv.addEventListener('click', closeDrawers);
      });
    };

    document.addEventListener('DOMContentLoaded', initCmDrawers);
    document.addEventListener('shopify:section:load', initCmDrawers);
    document.addEventListener('shopify:block:select', initCmDrawers);
  })();